@if (editing) {
  <div class="performance mt-3">
    @for (item of PerformanceIndicator | keys ; track item) {
      <div style="flex-grow:1">
        <div class="assessment-items">
          <div class="performance-indicator {{item.value}}" [ngClass]="{'clickable': editing}"
            (click)="setAssessment(item.key)">{{item.displayName}}
          </div>
          <div class="lead-reviewer assessment {{item.value}}">
            @if (+feedback.performanceIndicator === +item.key ) {
              <span>
                <i class="fa fa-caret-up"></i>
              </span>
            }
          </div>
        </div>
      </div>
    }
  </div>
} @else {
  @if (feedback.performanceIndicator) {
    <div
      class="performance-indicator mt-3 mb-3 {{PerformanceIndicator[review.feedbackEdit.performanceIndicator]}}">
      {{PerformanceIndicator[review.feedbackEdit.performanceIndicator] }}
    </div>
  } @else {
    No assessment yet.
  }
}
@if (canSendToRemediation) {
  <div>
    <button [disabled]="sendingToRemediation || sentToRemediation" class="btn btn-lg btn-block btn-primary"
      (click)="remediate()">
      @if (!sendingToRemediation && !sentToRemediation) {
        <span>Send to remediation</span>
      }
      @if (sentToRemediation) {
        <span>Sent to remediation</span>
      }
      @if (sendingToRemediation) {
        <span>Sending to remediation...</span>
      }
    </button>
  </div>
}


<app-collapsible [trigger]="isCoreCriteriaFeedbackRequired()">
  @if (isCoreCriteriaFeedbackRequired()) {
    <div>
      @if (!editing && !!feedback.coreCriteriaFeedback) {
        <div>
          <label>
            Core criteria feedback
          </label>
          <div [innerHTML]="feedback.coreCriteriaFeedback">
          </div>
        </div>
      }
      @if (editing) {
        <div>
          <label>
            Please provide additional feedback to be used for remediation periods.
          </label>
          <app-text-editor (contentChanged)="updateCoreCriteriaFeedback($event)" [content]="feedback.coreCriteriaFeedback"
            [hasFocus]="review.isCoreCriteriaFeedbackRequired()" [placeholder]="'Remediation feedback...'">
          </app-text-editor>
        </div>
      }
    </div>
  }
</app-collapsible>

